import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { Movie, ObjectType, Show } from '@/@types/graphql-types';

import PosterGraphql from '@/components/poster/PosterGraphql.vue';
import TitleDetailLink from '@/components/nav/links/TitleDetailLink.vue';
import WatchNowButtonNew from '@/components/buttons/WatchNowButtonNew.vue';
import BasicButton from '@/ui-components/BasicButton.vue';
import PictureComp from '@/components/picture/PictureComp.vue';

import { faBookmark, faCheck } from '@fortawesome/free-solid-svg-icons';
import { formatRuntime } from '@/helpers/title-helper';
import { useI18n } from '@/helpers/composables/useI18n';
import { SnowplowContext, SnowplowOldModuleContext } from '@/helpers/tracking/providers';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { useTitleWatchlist } from '@/helpers/composables/useTitleWatchlist';


export default /*#__PURE__*/_defineComponent({
  __name: 'UKHomeTop10SwiperSlide',
  props: {
    title: null,
    index: null,
    moduleName: null
  },
  setup(__props: any) {

const props = __props as {
	title: Movie | Show;
	index: number;
	moduleName: string;
};



const { t } = useI18n();

const releaseYear = computed(() => props.title.content.originalReleaseYear);

const runtime = computed(() => {
	if (props.title?.content?.runtime) {
		const runtimeValue = props.title.content.runtime!;
		const { translationKey, minutes, hours } = formatRuntime(runtimeValue);
		return t(translationKey, { minutes, hours }) as string;
	}
	return null;
});

const jwScore = computed(() => {
	return Math.round((props.title.content.scoring?.jwRating || 0) * 100);
});

const imdbScore = computed(() => {
	return props.title.content.scoring?.imdbScore?.toFixed(1);
});

const trackingLabel = computed(() => {
	if (props.title.objectType === ObjectType.Movie) return 'top_10_movies';
	if (props.title.objectType === ObjectType.Show) return 'top_10_shows';
	return '';
});

const moduleContext = computed(() => new SnowplowOldModuleContext('', -1, props.moduleName, ''));

const titleContext = computed(() => {
	return TrackingHelper.getTitleContextGraphql(props.title.objectId, props.title.objectType, undefined);
});

const imageUrls = computed(() => props.title.content.backdrops.map(backdrop => backdrop.backdropUrl));

const isInWatchlist = computed(() => {
	return !!props.title.watchlistEntryV2?.createdAt;
});

const mutationTitleDetails = computed(() => {
	return {
		objectId: props.title.objectId,
		objectType: props.title.objectType,
		title: props.title.content.title,
	};
});

const { setInWatchlist } = useTitleWatchlist(undefined, [titleContext.value, moduleContext.value]);

function addToWatchList() {
	setInWatchlist(props.title.id, isInWatchlist.value, mutationTitleDetails.value, {
		source: 'lists-panel',
	});
}

function preventNavigation($event: Event) {
	$event.preventDefault();
	$event.stopPropagation();
	$event.stopImmediatePropagation();
}

function handlePosterClick(title: any, index: number, contexts: SnowplowContext[] = []) {
	TrackingHelper.trackEvent(
		'userinteraction',
		{
			action: 'title_clicked',
			label: trackingLabel.value,
			value: index,
		},
		[...contexts, titleContext.value, moduleContext.value]
	);
}

function trackMoreClicked() {
	TrackingHelper.trackEvent(
		'userinteraction',
		{
			action: 'more_clicked',
			property: 'global_home_swiper',
		},
		[moduleContext.value, titleContext.value]
	);
}

return { __sfc: true,props, t, releaseYear, runtime, jwScore, imdbScore, trackingLabel, moduleContext, titleContext, imageUrls, isInWatchlist, mutationTitleDetails, setInWatchlist, addToWatchList, preventNavigation, handlePosterClick, trackMoreClicked, PosterGraphql, TitleDetailLink, WatchNowButtonNew, BasicButton, PictureComp, faBookmark, faCheck }
}

})